import { RequestExecutor } from "../../transport/request-executor";
import { DTONpmRegistryAccessTokenResponse, DTOUpdateRegistryInput, DTOUpdateRegistryOutput } from "../../dto";

export class WorkspaceNpmRegistryEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  getAccessToken(wsId: string) {
    return this.requestExecutor.json(
      `/workspaces/${wsId}/npm-registry/access-token`,
      DTONpmRegistryAccessTokenResponse
    );
  }

  update(wsId: string, body: DTOUpdateRegistryInput) {
    return this.requestExecutor.json(`/workspaces/${wsId}/npm-registry`, DTOUpdateRegistryOutput, {
      method: "PUT",
      body,
    });
  }
}
